module.exports = __webpack_public_path__ + "img/avatar.3309fa69.png";